import axios from 'axios'
import { auth } from '@/plugins/firebase'

const axiosAuth = axios.create();

axiosAuth.interceptors.request.use(async (config) => {
  const token = await auth.currentUser.getIdToken();

  config.headers.Authorization = `Bearer ${token}`;
  
  return config;
});

export default axiosAuth